import { SvgIcon } from '@mui/material';
import {
  mdiCoffee,
  mdiCoffeeOff,
  mdiExitToApp,
  mdiFormatSize,
  mdiGoogleCirclesCommunities,
  mdiSquareCircle,
  mdiPencil,
  mdiRestore,
  mdiWrench,
  mdiPaperRoll,
  mdiOfficeBuildingMarker,
  mdiEarth,
  mdiStoreClockOutline,
} from '@mdi/js';
import React from 'react';

/**
 * BreakDisplayIcon
 * @param style
 * @param props
 * @constructor
 */
export const BreakDisplayIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiCoffee} />
    </SvgIcon>
  );
};

/**
 * BreakDisplayOffIcon
 * @param style
 * @param props
 * @constructor
 */
export const BreakDisplayOffIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiCoffeeOff} />
    </SvgIcon>
  );
};

/**
 * EditIcon
 * @param style
 * @param props
 * @constructor
 */
export const EditIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiPencil} />
    </SvgIcon>
  );
};

/**
 * FontSizeIcon
 * @param style
 * @param props
 * @constructor
 */
export const FontSizeIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiFormatSize} />
    </SvgIcon>
  );
};

/**
 * InventoryLocationIcon
 * @param style
 * @param props
 * @constructor
 */
export const GlobalLocationIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiEarth} />
    </SvgIcon>
  );
};

/**
 * InventoryLocationIcon
 * @param style
 * @param props
 * @constructor
 */
export const InventoryLocationIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiOfficeBuildingMarker} />
    </SvgIcon>
  );
};

/**
 * LogoutIcon
 * @param sx
 * @param props
 * @constructor
 */
export const LogoutIcon = ({ sx, ...props }: any) => {
  return (
    <SvgIcon {...props} sx={sx}>
      <path d={mdiExitToApp} />
    </SvgIcon>
  );
};

/**
 * MCellCollectionIcon
 * @param style
 * @param props
 * @constructor
 */
export const MCellCollectionIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiGoogleCirclesCommunities} />
    </SvgIcon>
  );
};

/**
 * MCellIcon
 * @param style
 * @param props
 * @constructor
 */
export const MCellIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiSquareCircle} />
    </SvgIcon>
  );
};

/**
 * ResetIcon
 * @param style
 * @param props
 * @constructor
 */
export const ResetIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiRestore} />
    </SvgIcon>
  );
};

/**
 * RollUpIcon
 * @param style
 * @param props
 * @constructor
 */
export const RollUpIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiPaperRoll} />
    </SvgIcon>
  );
};

/**
 * VersionIcon
 * @param style
 * @param props
 * @constructor
 */
export const VersionIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiWrench} />
    </SvgIcon>
  );
};

/**
 * ScheduleIcon
 * @param style
 * @param props
 * @constructor
 */
export const ScheduleIcon = ({ style, ...props }: any) => {
  return (
    <SvgIcon {...props} style={style}>
      <path d={mdiStoreClockOutline} />
    </SvgIcon>
  );
};
